import React from 'react';
import cx from 'classnames';
import styles from './TabContent.module.scss';
import type { TabContentProps } from './TabContent.types';
import { useTab } from '../Tabs.Context';

const TabContent = (props: TabContentProps) => {
  const {
    className,
    children,
    value,
  } = props;

  const { currentTab } = useTab();

  return (
    <div
      className={cx(styles.tabContent, className)}
      style={{
        display: currentTab === value ? 'flex' : 'none',
      }}
    >
      {children}
    </div>
  );
};
export default TabContent;
